import { render } from "./v-table-r.vue?vue&type=template&id=17543a04"
import script from "./v-table-r.vue?vue&type=script&lang=js"
export * from "./v-table-r.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\vue\\e-justice-sud-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__